import React from "react";
import Productpage from "../../productpage2";
import SEO from "../../seo";

export default function NaturaLatex({ location }) {
  const data = {
    galleryImages: [
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-04.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-01.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-02.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-03.png",
    ],
    productName: "Natura Latex",
    descriptionTitle: "",
    descriptionText:
      "Natura Latex is made with a unique combination of luxurious HR (High Resilience) foam as core coupled with durable 100% Latex on top offering optimum support and comfort. The Talalay latex on top provides gentle cushioning and offers a natural elasticity that encourages spinal alignment.",
    availableSizes: "6″ & 8″",
    category: { title: "Latex Series", link: "/latex-mattress/" },
    points: [
      "High Resilience (HR) Foam",
      "Finest 100% Natural Talalay Latex top from Belgium ",
      "Natural elasticity that supports spine alignment",
    ],

    featuresText: [
      "Soft HD Eclipse Foam For Quilting",
      "Natural Belgium Latex",
      "HR Eclipse Foam",
    ],
    featuresImage:
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-11.png",

    warrantyIcons: [
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-06.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-07.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-08.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-09.png",
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-10.png",
    ],

    warrantyImage:
      "https://eclipsemattress.in/assets/images/products/natura-latex/Natura-Latex-05.png",
    price: "₹23,399 - ₹84,699",

    relatedProducts: [
      {
        title: "Portofino Latex",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/portofino-latex.jpg",
        link: "/latex-mattress/portofino-latex/",
      },
      {
        title: "Ortho Latex",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/ortho-latex.jpg",
        link: "/latex-mattress/ortho-latex/",
      },
      {
        title: "Tiara Cool",
        img: "https://eclipsemattress.in/assets/images/product_thumbnails/tiara-cool.jpg",
        link: "/patent-series-mattress/tiara-cool/",
      },
    ],
  };

  return (
    <div>
      <SEO
        title="Natura Latex Mattress | Eclipse International"
        description="Pressure relief and body contouring with the finest natural Talalay latex. Learn more about Eclipse's Natural Latex matress with a 10 year warranty."
        img="https://eclipsemattress.in/assets/linkpreviews/link-preview-naturalatex.jpg"
      />
      <Productpage location={location} product={data} />
    </div>
  );
}
